import { styled } from '@mui/material';

import CourseDetailsSettings from 'components/CourseDashboard/CourseDetailsSettings';
import { Box } from 'shell/components';

const Root = styled(Box)(({ theme }) => {
    return {
        paddingBottom: theme.spacing(16),
    };
});

const SettingsTab = ({ device, course, updateCourseSettings, openDeleteCourseDialog }) => {
    return (
        <Root>
            <CourseDetailsSettings
                device={device}
                course={course}
                updateCourseSettings={updateCourseSettings}
                openDeleteCourseDialog={openDeleteCourseDialog}
            />
        </Root>
    );
};

export default SettingsTab;
